"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateTime = void 0;
var formatDateTime = function (dateTimeText) {
    if (!dateTimeText) {
        return '-';
    }
    var dateTime = new Date(dateTimeText);
    return dateTime.toLocaleString();
};
exports.formatDateTime = formatDateTime;
//# sourceMappingURL=DateUtils.js.map